export default __webpack_public_path__ + "static/media/49_1_2.d5f0b64f.png";